import { Ticket, TicketClientsRequest } from 'vopay';
import { useState } from 'react';
import axios from 'axios';

import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useFetchTickets() {
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const source = axios.CancelToken.source();

  async function fetchTickets(params: TicketClientsRequest) {
    const res = await api.fetchTicketsClient(params, source);

    if (!res.Success) {
      throw new Error(res.ErrorMessage);
    }

    setTickets(res.Tickets);

    return res;
  }

  return {
    tickets,
    fetchTickets,
  };
}
